import React from "react";

const PlusSquare = ({ className = "", hideBorder = false }) => {
  return (
    <svg
      className={`h-3 w-2 text-brand-base-primary ${className}`}
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      {!hideBorder && <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />}
      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
    </svg>
  );
}

const AED = ({ width = 24, height = 24, className }) => {
  return (
    <svg
      version="1.2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 870"
      width={width}
      height={height}
      className={className}
      fill="currentColor"
    >
      <path
        id="Layer copy"
        d="m88.3 1c0.4 0.6 2.6 3.3 4.7 5.9 15.3 18.2 26.8 47.8 33 85.1 4.1 24.5 4.3 32.2 4.3 125.6v87h-41.8c-38.2 0-42.6-0.2-50.1-1.7-11.8-2.5-24-9.2-32.2-17.8-6.5-6.9-6.3-7.3-5.9 13.6 0.5 17.3 0.7 19.2 3.2 28.6 4 14.9 9.5 26 17.8 35.9 11.3 13.6 22.8 21.2 39.2 26.3 3.5 1 10.9 1.4 37.1 1.6l32.7 0.5v43.3 43.4l-46.1-0.3-46.3-0.3-8-3.2c-9.5-3.8-13.8-6.6-23.1-14.9l-6.8-6.1 0.4 19.1c0.5 17.7 0.6 19.7 3.1 28.7 8.7 31.8 29.7 54.5 57.4 61.9 6.9 1.9 9.6 2 38.5 2.4l30.9 0.4v89.6c0 54.1-0.3 94-0.8 100.8-0.5 6.2-2.1 17.8-3.5 25.9-6.5 37.3-18.2 65.4-35 83.6l-3.4 3.7h169.1c101.1 0 176.7-0.4 187.8-0.9 19.5-1 63-5.3 72.8-7.4 3.1-0.6 8.9-1.5 12.7-2.1 8.1-1.2 21.5-4 40.8-8.9 27.2-6.8 52-15.3 76.3-26.1 7.6-3.4 29.4-14.5 35.2-18 3.1-1.8 6.8-4 8.2-4.7 3.9-2.1 10.4-6.3 19.9-13.1 4.7-3.4 9.4-6.7 10.4-7.4 4.2-2.8 18.7-14.9 25.3-21 25.1-23.1 46.1-48.8 62.4-76.3 2.3-4 5.3-9 6.6-11.1 3.3-5.6 16.9-33.6 18.2-37.8 0.6-1.9 1.4-3.9 1.8-4.3 2.6-3.4 17.6-50.6 19.4-60.9 0.6-3.3 0.9-3.8 3.4-4.3 1.6-0.3 24.9-0.3 51.8-0.1 53.8 0.4 53.8 0.4 65.7 5.9 6.7 3.1 8.7 4.5 16.1 11.2 9.7 8.7 8.8 10.1 8.2-11.7-0.4-12.8-0.9-20.7-1.8-23.9-3.4-12.3-4.2-14.9-7.2-21.1-9.8-21.4-26.2-36.7-47.2-44l-8.2-3-33.4-0.4-33.3-0.5 0.4-11.7c0.4-15.4 0.4-45.9-0.1-61.6l-0.4-12.6 44.6-0.2c38.2-0.2 45.3 0 49.5 1.1 12.6 3.5 21.1 8.3 31.5 17.8l5.8 5.4v-14.8c0-17.6-0.9-25.4-4.5-37-7.1-23.5-21.1-41-41.1-51.8-13-7-13.8-7.2-58.5-7.5-26.2-0.2-39.9-0.6-40.6-1.2-0.6-0.6-1.1-1.6-1.1-2.4 0-0.8-1.5-7.1-3.5-13.9-23.4-82.7-67.1-148.4-131-197.1-8.7-6.7-30-20.8-38.6-25.6-3.3-1.9-6.9-3.9-7.8-4.5-4.2-2.3-28.3-14.1-34.3-16.6-3.6-1.6-8.3-3.6-10.4-4.4-35.3-15.3-94.5-29.8-139.7-34.3-7.4-0.7-17.2-1.8-21.7-2.2-20.4-2.3-48.7-2.6-209.4-2.6-135.8 0-169.9 0.3-169.4 1zm330.7 43.3c33.8 2 54.6 4.6 78.9 10.5 74.2 17.6 126.4 54.8 164.3 117 3.5 5.8 18.3 36 20.5 42.1 10.5 28.3 15.6 45.1 20.1 67.3 1.1 5.4 2.6 12.6 3.3 16 0.7 3.3 1 6.4 0.7 6.7-0.5 0.4-100.9 0.6-223.3 0.5l-222.5-0.2-0.3-128.5c-0.1-70.6 0-129.3 0.3-130.4l0.4-1.9h71.1c39 0 78 0.4 86.5 0.9zm297.5 350.3c0.7 4.3 0.7 77.3 0 80.9l-0.6 2.7-227.5-0.2-227.4-0.3-0.2-42.4c-0.2-23.3 0-42.7 0.2-43.1 0.3-0.5 97.2-0.8 227.7-0.8h227.2zm-10.2 171.7c0.5 1.5-1.9 13.8-6.8 33.8-5.6 22.5-13.2 45.2-20.9 62-3.8 8.6-13.3 27.2-15.6 30.7-1.1 1.6-4.3 6.7-7.1 11.2-18 28.2-43.7 53.9-73 72.9-10.7 6.8-32.7 18.4-38.6 20.2-1.2 0.3-2.5 0.9-3 1.3-0.7 0.6-9.8 4-20.4 7.8-19.5 6.9-56.6 14.4-86.4 17.5-19.3 1.9-22.4 2-96.7 2h-76.9v-129.7-129.8l220.9-0.4c121.5-0.2 221.6-0.5 222.4-0.7 0.9-0.1 1.8 0.5 2.1 1.2z"
      />
    </svg>
  );
};

const AllOutlets = ({ className = "" }) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="40" height="40" rx="20" fill="#ECEBFC" />
    <path
      d="M28.5 19.3V15.04C28.5 11.01 27.56 10 23.78 10H16.22C12.44 10 11.5 11.01 11.5 15.04V26.3C11.5 28.96 12.96 29.59 14.73 27.69L14.74 27.68C15.56 26.81 16.81 26.88 17.52 27.83L18.53 29.18"
      stroke="#928FEF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16 15H24" stroke="#928FEF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 19H23" stroke="#928FEF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M26.211 22.7703L22.671 26.3103C22.531 26.4503 22.401 26.7103 22.371 26.9003L22.181 28.2503C22.111 28.7403 22.451 29.0803 22.941 29.0103L24.291 28.8203C24.481 28.7903 24.751 28.6603 24.881 28.5203L28.421 24.9803C29.031 24.3703 29.321 23.6603 28.421 22.7603C27.531 21.8703 26.821 22.1603 26.211 22.7703Z"
      stroke="#928FEF"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.6992 23.2803C25.9992 24.3603 26.8392 25.2003 27.9192 25.5003"
      stroke="#928FEF"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AllItems = ({ className = "" }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="40" height="40" rx="20" fill="#F9E7F2" />
    <path
      d="M20 13.5601H30"
      stroke="#FF9BDF"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.22 10H27.78C29.56 10 30 10.44 30 12.2V16.31C30 18.07 29.56 18.51 27.78 18.51H22.22C20.44 18.51 20 18.07 20 16.31V12.2C20 10.44 20.44 10 22.22 10Z"
      stroke="#FF9BDF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 25.0601H20"
      stroke="#FF9BDF"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.22 21.5H17.78C19.56 21.5 20 21.94 20 23.7V27.81C20 29.57 19.56 30.01 17.78 30.01H12.22C10.44 30.01 10 29.57 10 27.81V23.7C10 21.94 10.44 21.5 12.22 21.5Z"
      stroke="#FF9BDF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 23C30 26.87 26.87 30 23 30L24.05 28.25"
      stroke="#FF9BDF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 17C10 13.13 13.13 10 17 10L15.95 11.75"
      stroke="#FF9BDF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChatBubbleIcon = ({ className = "" }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="40" height="40" rx="20" fill="#D4F6E3" />
    <path
      d="M28.5 19.3V15.04C28.5 11.01 27.56 10 23.78 10H16.22C12.44 10 11.5 11.01 11.5 15.04V26.3C11.5 28.96 12.96 29.59 14.73 27.69L14.74 27.68C15.56 26.81 16.81 26.88 17.52 27.83L18.53 29.18"
      stroke="#56E196"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.2 29.4C27.9673 29.4 29.4 27.9673 29.4 26.2C29.4 24.4327 27.9673 23 26.2 23C24.4327 23 23 24.4327 23 26.2C23 27.9673 24.4327 29.4 26.2 29.4Z"
      stroke="#56E196"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 30L29 29"
      stroke="#56E196"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 15H24"
      stroke="#56E196"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 19H23"
      stroke="#56E196"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const VoucherIcon = ({ className = "" }) => (
  <svg
    width="28"
    height="22"
    viewBox="0 0 28 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.677 20.3371L16.6848 17.6666C16.6848 16.9302 17.2832 16.3333 18.0214 16.3333C18.7596 16.3333 19.3581 16.9302 19.3581 17.6666V20.3019C19.3581 20.9439 19.3581 21.265 19.5639 21.4618C19.7698 21.6587 20.0848 21.6453 20.7147 21.6186C23.1987 21.5135 24.7247 21.1775 25.8004 20.1045C26.8786 19.0289 27.2145 17.5021 27.3191 15.014C27.3398 14.5205 27.3502 14.2738 27.258 14.1092C27.1659 13.9446 26.7981 13.7392 26.0624 13.3284C25.2454 12.8721 24.6931 12.0004 24.6931 10.9999C24.6931 9.99949 25.2454 9.12773 26.0624 8.67146C26.7981 8.26063 27.1659 8.05522 27.258 7.89062C27.3502 7.72602 27.3398 7.47931 27.3191 6.98588C27.2145 4.49778 26.8786 2.97089 25.8004 1.89535C24.6301 0.727971 22.9268 0.432992 20.0369 0.358455C19.6641 0.348839 19.3581 0.649491 19.3581 1.02149V4.33325C19.3581 5.06963 18.7596 5.66659 18.0214 5.66659C17.2832 5.66659 16.6848 5.06963 16.6848 4.33325L16.6751 0.997987C16.674 0.630552 16.3751 0.333252 16.0068 0.333252H11.3265C6.28568 0.333252 3.76526 0.333252 2.19927 1.89535C1.12105 2.97089 0.785212 4.49778 0.680607 6.98588C0.659862 7.47931 0.64949 7.72602 0.741629 7.89062C0.833769 8.05522 1.20161 8.26063 1.93728 8.67146C2.75431 9.12773 3.3066 9.99949 3.3066 10.9999C3.3066 12.0004 2.75431 12.8721 1.93728 13.3284C1.20161 13.7392 0.833768 13.9446 0.741629 14.1092C0.64949 14.2738 0.659862 14.5205 0.680607 15.014C0.785212 17.5021 1.12105 19.0289 2.19927 20.1045C3.76526 21.6666 6.28568 21.6666 11.3265 21.6666H15.3404C15.9688 21.6666 16.283 21.6666 16.4786 21.472C16.6743 21.2774 16.6752 20.964 16.677 20.3371ZM19.3581 12.3333V9.66659C19.3581 8.93021 18.7596 8.33325 18.0214 8.33325C17.2832 8.33325 16.6848 8.93021 16.6848 9.66659V12.3333C16.6848 13.0696 17.2832 13.6666 18.0214 13.6666C18.7596 13.6666 19.3581 13.0696 19.3581 12.3333Z"
      fill="#FE5900"
    />
  </svg>
);

export { PlusSquare, AED, VoucherIcon, AllOutlets, AllItems, ChatBubbleIcon };